import { render } from "./ApprovalTable.vue?vue&type=template&id=0313c8d3&scoped=true"
const script = {}

import "./ApprovalTable.vue?vue&type=style&index=0&id=0313c8d3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0313c8d3"]])

export default __exports__